// Shared client-side helpers for estimating model cost from token usage.
// Prices in `pricingGraduations` are USD per 1,000,000 tokens.

// Pick the pricing graduation that applies to a given input-token count.
// Graduations are ordered ascending by `fromPromptLength`; we return the last
// one whose threshold the prompt has reached.
export function getGraduation(model, inputTokens) {
  const grads = model?.pricingGraduations;
  if (!grads?.length) return null;
  let chosen = grads[0];
  for (const g of grads) {
    if (inputTokens >= g.fromPromptLength) chosen = g;
    else break;
  }
  return chosen;
}

// Rough USD cost of a single call with the given token counts.
// Uses list input/output prices only — it intentionally ignores prompt
// caching, reasoning tokens and per-use tool costs, so it is an estimate
// for comparison, not the exact billed amount.
export function estimateCallCostUsd(model, tokensIn, tokensOut) {
  const g = getGraduation(model, tokensIn);
  if (!g) return 0;
  return ((tokensIn || 0) * g.input + (tokensOut || 0) * g.output) / 1_000_000;
}
